import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { resetPassword } from '../services/authService';
import './Login.css'; // Aynı stil dosyasını kullanıyoruz

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [token, setToken] = useState('');
  const [tokenError, setTokenError] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // URL'den token parametresini al
    const queryParams = new URLSearchParams(location.search);
    const tokenParam = queryParams.get('token');
    
    if (!tokenParam) {
      setTokenError(true);
      setError('Geçersiz veya eksik şifre sıfırlama bağlantısı. Lütfen tekrar şifre sıfırlama talebinde bulunun.');
    } else {
      setToken(tokenParam);
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Şifre kontrolü
    if (password.length < 6) {
      setError('Şifre en az 6 karakter uzunluğunda olmalıdır');
      return;
    }
    
    if (password !== confirmPassword) {
      setError('Şifreler eşleşmiyor');
      return;
    }

    try {
      setLoading(true);
      
      const response = await resetPassword(token, password);
      
      if (response.message) {
        setSuccess(true);
        toast.success('Şifreniz başarıyla sıfırlandı');
        
        // 3 saniye sonra login sayfasına yönlendir
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (error) {
      console.error('Şifre sıfırlama hatası:', error);
      
      if (error.message?.includes('Geçersiz veya süresi dolmuş token')) {
        setError('Bu bağlantının süresi dolmuş. Lütfen yeni bir şifre sıfırlama talebinde bulunun.');
      } else {
        setError(error.message || 'Şifre sıfırlama sırasında bir hata oluştu');
      }
      
      toast.error(error.message || 'Şifre sıfırlama sırasında bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  // Token yoksa veya geçersizse form gösterme
  if (tokenError) {
    return (
      <Container className="login-container page-transition">
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={6} lg={5}>
            <Card className="shadow-sm login-card">
              <Card.Body className="p-1">
                <div className="text-center mb-4">
                  <h2 className="fw-bold">Şifre Sıfırlama</h2>
                </div>
                <Alert variant="danger">
                  <p className="mb-2">{error}</p>
                  <div className="text-center mt-3">
                    <Link to="/forgot-password" className="btn btn-primary">
                      Şifre Sıfırlama Talep Et
                    </Link>
                  </div>
                </Alert>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="login-container page-transition">
      <Row className="justify-content-center align-items-center min-vh-100">
        <Col md={6} lg={5}>
          <Card className="shadow-sm login-card">
            <Card.Body className="p-1">
              <div className="text-center mb-4">
                <h2 className="fw-bold">Şifre Sıfırlama</h2>
                <p className="text-muted">Lütfen yeni şifrenizi belirleyin</p>
              </div>

              {error && <Alert variant="danger">{error}</Alert>}
              
              {success ? (
                <Alert variant="success">
                  <p className="mb-2">Şifreniz başarıyla sıfırlandı!</p>
                  <p className="mb-0">Giriş sayfasına yönlendiriliyorsunuz...</p>
                </Alert>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Yeni Şifre</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Yeni şifrenizi girin"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      disabled={loading}
                    />
                    <Form.Text className="text-muted">
                      Şifreniz en az 6 karakter uzunluğunda olmalıdır.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Şifre Tekrar</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Şifrenizi tekrar girin"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mb-3"
                    disabled={loading}
                  >
                    {loading ? 'İşleniyor...' : 'Şifremi Sıfırla'}
                  </Button>

                  <div className="text-center">
                    <p className="mb-0">
                      <Link to="/login" className="text-primary text-decoration-none">
                        Giriş sayfasına dön
                      </Link>
                    </p>
                  </div>
                </Form>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword; 